/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Increase_TimecodeInputs */

const en_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase timecode by 1.001/1.000`)
};

const fr_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter le timecode de 1,001/1,000`)
};

const de_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhöhen Sie den Timecode um 1,001/1,000.`)
};

const it_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta il timecode di 1,001/1,000`)
};

const ru_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте временной код на 1.001/1.000`)
};

const es_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar el código de tiempo en 1.001/1.000`)
};

const zh_cn2_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码增加 1.001/1.000`)
};

const ja_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードを1.001/1.000ずつ増やす`)
};

const hi_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड को 1.001/1.000 से बढ़ाएँ`)
};

const pt_pt2_increase_timecode = /** @type {(inputs: Increase_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar o código de tempo em 1,001/1,000`)
};

/**
* | output |
* | --- |
* | "Increase timecode by 1.001/1.000" |
*
* @param {Increase_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const increase_timecode = /** @type {((inputs?: Increase_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Increase_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_increase_timecode(inputs)
	if (locale === "de") return de_increase_timecode(inputs)
	if (locale === "it") return it_increase_timecode(inputs)
	if (locale === "ru") return ru_increase_timecode(inputs)
	if (locale === "es") return es_increase_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_increase_timecode(inputs)
	if (locale === "ja") return ja_increase_timecode(inputs)
	if (locale === "hi") return hi_increase_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_increase_timecode(inputs)
	return en_increase_timecode(inputs)
});